import { Layout, Login, Register, Addresses, Accounting, Orders, OrderDetails, Settings, Usermedia, Activate } from '@/views/account';

export default {
    path: '/shop/account',
    component: Layout,
    children: [
        { path: '', redirect: 'login' },
        { path: 'login', component: Login },
        { path: 'logout' },
        { path: 'register', component: Register },
        { path: 'activate', component: Activate },
        { path: 'addresses', component: Addresses, meta: { requiresAuth: true } },
        { path: 'accounting', component: Accounting, meta: { requiresAuth: true } },
        { path: 'orders', component: Orders, meta: { requiresAuth: true } },
        { path: 'orders/:id', component: OrderDetails, meta: { requiresAuth: true } },
        { path: 'settings', component: Settings, meta: { requiresAuth: true } },
        { path: 'usermedia/:gallerypath(.*)*', component: Usermedia }
    ]
};
    